import React, { Component } from 'react'
import debounce from 'lodash/debounce'

import styles from './search.css'
import SVGIcon from '../svg-icon/svg-icon'
import SearchIcon from 'assets/images/icons/search.svg'
import DeleteIcon from 'assets/images/icons/cancel.svg'
import SearchDropdown from './search-dropdown/search-dropdown'
import clsx from 'clsx'

class Search extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: '',
    }

    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onDeleteClick = this.onDeleteClick.bind(this)
    this.onInputChanged = debounce((event) => {
      const { onSearchInputChange } = this.props
      const value = event.target.value

      this.setState({ searchTerm: value })
      onSearchInputChange(value)
    }, 300)
  }

  onDeleteClick() {
    const { onSearchInputChange } = this.props

    if (!this.refs.searchInput) return

    this.refs.searchInput.value = ''
    this.setState({ searchTerm: '' })
    onSearchInputChange('')
  }

  onFocus() {
    const { onFocus } = this.props
    if (!this.refs.searchInput) return
    this.refs.searchInput.select()
    onFocus && onFocus()
  }

  onBlur(event) {
    const { onBlur } = this.props
    onBlur && onBlur(event)
  }

  onInputChange(event) {
    event.persist()
    this.onInputChanged(event)
  }

  buildDropDown() {
    const { searchTerm } = this.state
    const { items, dropdownContent, isLoading } = this.props

    if (!dropdownContent) return null

    if (searchTerm && items.length <= 0) {
      return (
        <div>Nichts</div>
      )
    }

    if (!searchTerm && items.length <= 0) {
      return null
    }

    return (
      <SearchDropdown isLoading={isLoading}>
        {dropdownContent}
      </SearchDropdown>
    )
  }

  render() {
    const { placeholder, hideClear, customClass, onClick } = this.props
    const { searchTerm } = this.state
    const dropdown = this.buildDropDown()

    return (
      <div className={`${customClass || ''}`}>
        <div className={styles.inputWrapper}>
          <span className={clsx(styles.deleteIcon, (searchTerm === '' || hideClear) && styles.hide)} onClick={this.onDeleteClick}>
            <SVGIcon width='10px' height='10px' svg={DeleteIcon} />
          </span>
          <input
            ref='searchInput'
            type='text'
            placeholder={placeholder}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.onInputChange}
            onClick={() => onClick && onClick()}
            className={styles.input} />
          <span className={styles.icon}>
            <SVGIcon width='16px' height='16px' svg={SearchIcon} />
          </span>
        </div>
        {dropdown}
      </div>
    )
  }
}

export default Search
